<div class="update-banner" *ngIf="updateAvailable$ | async" role="status" aria-live="polite">
  <span class="update-banner-text">
    <span>A new version of TRACit is available.</span>
    <span class="update-banner-countdown" aria-hidden="true">Refreshing in {{ secondsUntilReload$ | async }}s.</span>
    <span class="visually-hidden">This page will refresh automatically in {{ countdownSeconds }} seconds.</span>
  </span>
  <span class="update-banner-actions">
    <button type="button" class="btn btn-sm btn-light update-banner-refresh" (click)="refresh()">Refresh now</button>
    <button type="button" class="btn btn-sm update-banner-snooze" (click)="snooze()">Remind me in 5 mins</button>
  </span>
</div>
